import { Component, OnInit } from '@angular/core';
import { AdSearchService } from 'src/app/shared/services/adsearch.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { ViewService } from '../view.service';

@Component({
  selector: 'app-advertise',
  templateUrl: './advertise.component.html',
  styleUrls: ['./advertise.component.scss']
})

/*
Decidir o bloco de telefones, o que fazer
*/
export class AdvertiseComponent extends AdUtils  implements OnInit{

  base = "realtor/";
  person:any = {};
  ads: any = [];
  title: any = [];
  citys: any = [];
  
  classItem = 'col-12 col-md-6 col-bg-4 mb-4';

  filterType = true;

  constructor(
    protected srs: AdSearchService,
    protected gs: GeneralService,
    protected vs : ViewService
  ) {
    super(srs, gs, vs);

  }

  setDefault(){
  }
  
  eventCallback(){}


  setFilterType(id){
    this.filterType = id;
  }

  ngOnInit(){
    this.person = this.data || {};
    this.ads = this.data?.ads?.list?.hits?.hits || [];

    if(this.person?.avatar){
      this.person.avatar = this.gs.adjustAvatarFiles(this.person);
      this.person.avatarImg = this.getOwner('image');
    }
  }

  cityFilters(){
    let citys = [];
    for (var item of this.ads.list){
      citys.push(item.address_city);
    }

    this.citys = Array.from(new Set(citys));
  }

}
